<template>
  <div class="">
    <v-card v-for="(item, index) in MapQueryLayer_Layers_Select" :key="index" :loading="item.IsLoading">
      <v-card-title class="pa-1 ml-2 mt-1 text-subtitle-1">{{
        item.Label
      }}</v-card-title>
      <v-card-text class="pa-1" v-html="item.Resut"></v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    // Legenda - základní seznam složek
    MapQueryLayer_Layers_Select: null,
  },
};
</script>

<style>
.MqPanel {
  font: normal 1em/1.5em "Arial CE", "Helvetica CE", Arial, Helvetica,
    sans-serif;
  overflow-wrap: normal;
}

.MqPanel .MqVypisTab {
  font-size: 1em;
}

.MqPanel .MqVypisTabItem {
  border: solid #565656 0.125em;
}

.MqPanel .MqVypisDiv {
  background-color: #006e00;
}

.MqPanel .MqVypisZvyr {
  font-size: 1.1429em !important;
  color: #ffd700 !important;
  background-color: #565656 !important;
  width: 100% !important;
}

.MqPanel .MqVypisDiv>div {
  color: #ffffff;
  padding: 0.25em 0.375em 0.25em 0.375em;
  display: inline-block;
  vertical-align: top;
}

.MqPanel .MqVypisDiv div:nth-child(2n + 1) {
  width: 11em;
  color: #90ee90;
}

.MqPanel .MqVypisDiv div:nth-child(2n) {
  text-align: left;
}

.MqPanel .MqAlert {
  color: #ffffff !important;
  background-color: #ff0000 !important;
  font-weight: bold;
  padding-left: 0.25em;
  padding-right: 0.25em;
  margin-left: 1em;
  margin-right: 1em;
}

.MqPanel .MqTextZvyr {
  color: orange !important;
  font-weight: bold;
}

.MqPanel img {
  width: 2.5em;
  height: 2.5em;
  background-color: white;
}

.MqPanel img:hover {
  transform: scale(2, 2);
  transform-origin: 0%;
}

.MqPanel .MqImg_1 {
  width: 2.5em ;
  height: 2.5em ;
}

.MqPanel .MqImgImg_1:hover {
  transform: scale(2, 2);
  transform-origin: 0%;
}

/* čtverec */
.MqPanel .MqSqr_1 {
  width: 2.5em !important;
  height: 2.5em !important;
  background-color: white;
  border: 4px solid black;
}

.MqPanel .MqSqr_1:hover {
  transform: scale(2, 2);
  transform-origin: 0%;
}

/* šířka auto, text bílý */
.MqPanel .MqVypis2  {
  width: auto !important;
  color: white !important;
}


/* šířka 3em */
.MqPanel .MqW3 {
  width: 3em !important;
}

/* vertikální centrování */
.MqPanel .MqVc {
  display: flex;
  align-items: center;
}
</style>